import React from 'react';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import { toast } from 'react-toastify';
import { SettingType } from './ui/SettingType';
import { statutOptions } from './utils/statusOptions';

const EditTypeInterventionSettings = () => {
  // Navigation
  const currentTypeIntervention = useLocation().state;
  const navigate = useNavigate();

  // Etats (données)
  const [typeIntervention, setTypeIntervention] = useState(currentTypeIntervention.name);
  const [type, setType] = useState(currentTypeIntervention.type);

  // handle setting type
  const handleType = (e) => {
    console.log(e.target.value);
    
    setType(e.target.value);
  };

  //  🌱🌱 init store(services)   🌱🌱
  const updateTypeIntervention = useStoreActions(
    (actions) => actions.middleware.SettingsMiddleware.updateTypeIntervention
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await updateTypeIntervention({
        id: currentTypeIntervention.id,
        typeIntervention: typeIntervention,
        type: type,
      });
      console.log('DATA', res);
      if (res) {
        navigate(-1);
      }
    } catch (error) {
      console.log('error', error);
      toast.error("❗️ Une erreur est survenue lors de la création de la nature d'intervention");
    }
  };
  return (
    <section className="flex flex-col h-screen">
      {/* Header */}
      <div className="pt-11 pb-4 border-b border-white-admin mb-3 mx-14">
        <h3 className="font-semibold">Modifier la nature de l'intervention</h3>
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="flex flex-col flex-grow"
      >
        <div className="flex flex-col gap-4 mx-14 py-5">
          <div className='flex gap-x-4 items-center'>
            <label htmlFor="name">Nature de l'intervention</label>
            <input
              className="w-[318px] py-3 pl-5 border border-white-admin rounded-lg text-sm input"
              type="text"
              placeholder="Nom du matériel"
              onChange={(e) => setTypeIntervention(e.target.value)}
              value={typeIntervention}
            />
          </div>
          <div className='flex gap-x-4 items-center'>
            <label htmlFor="type">Type d'intervention</label>
            <SettingType type={statutOptions} className={`text-sm rounded-lg border border-white-admin focus:outline-none`} setType={handleType} />
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="mt-auto py-4 flex justify-between items-center border-t border-white-admin px-14">
          <Link
            to="/settings/purchase-order"
            className="cursor-pointer border border-gray-admin rounded-lg"
          >
            <button className="py-3 px-5 text-blue-admin">Annuler</button>
          </Link>
          <div className="cursor-pointer bg-yellow-admin rounded-lg">
            <button
              type="submit"
              className="py-3 px-5 text-blue-admin"
            >
              Enregistrer les Modifications
            </button>
          </div>
        </div>
      </form>
    </section>
  );
};

export default EditTypeInterventionSettings;
